import { $authHost } from "./index";

const getAnalytic = async (query) => {
  const { data } = await $authHost.get(`/info/api/v1/analytic?${query}`);
  return data;
};

export { getAnalytic };
